// import { useState, useEffect, useRef } from 'react';
// import { toast } from 'react-toastify';
// import Cookies from 'js-cookie';
// import axios from 'axios';
// import { useGeolocated } from 'react-geolocated';
// import { NIGHT_EYE_API_URL } from '../../Process';
// import { notifyError, notifySuccess } from '../../HelperMethods';
// import axiosInstance from '../../API_Master/AxiosInstance';
// import { useGetViolatoinTypeDetails } from '../../API_Master/GetAPI';

// const ShopReportModal = ({ isOpen, refetch, onClose, selectedShop }) => {
//   const { data: violationData = [] } = useGetViolatoinTypeDetails();
//   // console.log(violationData, "violationData");

//   const [form, setForm] = useState({
//     Title: '',
//     Description: '',
//     violationTypes: [],           // ← new: array of selected violation type IDs
//     ShopReportImage: null,
//     Latitude: '',
//     Longitude: '',
//     Address: '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // Camera states
//   const [cameraActive, setCameraActive] = useState(false);
//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const [imagePreview, setImagePreview] = useState(null);

//   // ── Geolocation ───────────────────────────────────────────────────────
//   const {
//     coords,
//     isGeolocationAvailable,
//     isGeolocationEnabled,
//     error: geoError,
//   } = useGeolocated({
//     positionOptions: {
//       enableHighAccuracy: true,
//       timeout: 15000,
//       maximumAge: 0,
//     },
//     watchPosition: false,
//     userDecisionTimeout: 10000,
//   });

//   useEffect(() => {
//     if (!isOpen) return;

//     if (!isGeolocationAvailable) {
//       toast.warn('Geolocation is not supported by your browser');
//       setForm((prev) => ({
//         ...prev,
//         Latitude: '0',
//         Longitude: '0',
//         Address: 'Geolocation not supported',
//       }));
//       return;
//     }

//     if (!isGeolocationEnabled) {
//       toast.warn('Please enable location access in your browser settings');
//       setForm((prev) => ({
//         ...prev,
//         Latitude: '0',
//         Longitude: '0',
//         Address: 'Location access disabled',
//       }));
//       return;
//     }

//     if (geoError) {
//       console.error('Geolocation error:', geoError);
//       let msg = 'Location access failed.';
//       if (geoError.code === 1) msg = 'Location permission denied.';
//       if (geoError.code === 2) msg = 'Position unavailable.';
//       if (geoError.code === 3) msg = 'Location request timed out.';
//       toast.warn(msg);
//       setForm((prev) => ({
//         ...prev,
//         Latitude: '0',
//         Longitude: '0',
//         Address: 'Location error',
//       }));
//       return;
//     }

//     if (coords) {
//       const { latitude, longitude } = coords;
//       fetch(
//         `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`
//       )
//         .then((res) => res.json())
//         .then((data) => {
//           const address = data.display_name || `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`;
//           setForm((prev) => ({
//             ...prev,
//             Latitude: latitude.toFixed(6),
//             Longitude: longitude.toFixed(6),
//             Address: address.substring(0, 150),
//           }));
//         })
//         .catch((err) => {
//           console.error('Reverse geocoding error:', err);
//           setForm((prev) => ({
//             ...prev,
//             Latitude: latitude.toFixed(6),
//             Longitude: longitude.toFixed(6),
//             Address: `${latitude.toFixed(5)}, ${longitude.toFixed(5)} (address lookup failed)`,
//           }));
//         });
//     }
//   }, [isOpen, isGeolocationAvailable, isGeolocationEnabled, coords, geoError]);

//   // ── Camera Functions ──────────────────────────────────────────────────
//   const handleOpenCamera = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: {
//           facingMode: 'environment',
//           width: { ideal: 1280 },
//           height: { ideal: 720 },
//         },
//       });
//       if (videoRef.current) {
//         videoRef.current.srcObject = stream;
//         videoRef.current.play().catch((e) => console.error('Video play failed:', e));
//         setCameraActive(true);
//       }
//     } catch (err) {
//       console.error('Camera access error:', err);
//       let message = 'Failed to access camera.';
//       if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
//         message = 'Camera permission denied. Please enable in browser settings.';
//       } else if (err.name === 'NotFoundError') {
//         message = 'No camera detected on this device.';
//       }
//       notifyError(message);
//     }
//   };

//   const takePhoto = () => {
//     if (!videoRef.current || !canvasRef.current) return;
//     const context = canvasRef.current.getContext('2d');
//     context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
//     canvasRef.current.toBlob(
//       (blob) => {
//         if (!blob) return;
//         const file = new File([blob], `violation-report-${Date.now()}.jpg`, { type: 'image/jpeg' });
//         setForm((prev) => ({ ...prev, ShopReportImage: file }));
//         setImagePreview(URL.createObjectURL(file));

//         videoRef.current.srcObject?.getTracks().forEach((track) => track.stop());
//         videoRef.current.srcObject = null;
//         setCameraActive(false);
//         toast.success('Photo captured successfully');
//       },
//       'image/jpeg',
//       0.85
//     );
//   };

//   // ── Violation Type Checkbox Handler ───────────────────────────────────
//   const handleViolationTypeChange = (id) => {
//     setForm((prev) => {
//       const current = prev.violationTypes;
//       if (current.includes(id)) {
//         return { ...prev, violationTypes: current.filter((v) => v !== id) };
//       } else {
//         return { ...prev, violationTypes: [...current, id] };
//       }
//     });
//   };

//   const handleSubmit = async () => {
//     toast.dismiss();

//     if (!form.Title.trim()) {
//       notifyError('Violation Title is required');
//       return;
//     }
//     if (!form.Description.trim()) {
//       notifyError('Description is required');
//       return;
//     }
//     if (form.violationTypes.length === 0) {
//       notifyError('Please select at least one Violation Type');
//       return;
//     }
//     if (!form.ShopReportImage) {
//       notifyError('Proof photo is required');
//       return;
//     }
//     if (!form.Latitude || !form.Longitude) {
//       notifyError('Location not available yet');
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const formData = new FormData();
//       formData.append('ShopDetailID', selectedShop.ShopDetailID || '');
//       formData.append('Title', form.Title.trim());
//       formData.append('Description', form.Description.trim());

//       // Send violation types as comma-separated string (most common backend format)
//       formData.append('ViolationTypeIDs', form.violationTypes.join(','));

//       const now = new Date();
//       formData.append('ReportDate', now.toLocaleDateString('en-GB'));
//       formData.append('ReportTime', now.toLocaleTimeString('en-US', {
//         hour12: false,
//         hour: '2-digit',
//         minute: '2-digit',
//       }));
//       formData.append('Latitude', form.Latitude || '0');
//       formData.append('Longitude', form.Longitude || '0');
//       formData.append('Address', form.Address || '');
//       formData.append('CreatedByUserID', Cookies.get('NIGHT_EYE_USER_ID') || '');

//       if (form.ShopReportImage) {
//         formData.append('ShopReportImage', form.ShopReportImage);
//       }

//       const response = await axiosInstance.post(
//         `${NIGHT_EYE_API_URL}shopReportDetail/setShopReportDetail`,
//         formData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       if (response?.data?.status === true) {
//         notifySuccess('Report submitted successfully!');
//         refetch();
//         onClose();
//       }
//     } catch (error) {
//       console.error('Report submission failed:', error);
//       notifyError(error.response?.data?.message || 'Failed to submit report');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-3 sm:p-4">
//       <div
//         className="
//           bg-white dark:bg-gray-900
//           rounded-2xl shadow-2xl
//           w-full max-w-lg
//           max-h-[92vh] sm:max-h-[90vh]
//           overflow-y-auto overscroll-contain
//           border border-gray-200 dark:border-gray-700
//           scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600
//         "
//       >
//         {/* Header */}
//         <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50/70 dark:bg-gray-800/40 sticky top-0 z-10 backdrop-blur-sm">
//           <div className="flex items-center justify-between">
//             <h2 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
//               Report Violation
//             </h2>
//             <button
//               onClick={onClose}
//               disabled={isSubmitting}
//               className="text-gray-500 hover:text-gray-700 dark:text-gray-400 text-xl sm:text-2xl leading-none"
//             >
//               ×
//             </button>
//           </div>
//           <p className="mt-0.5 text-xs sm:text-sm text-gray-600 dark:text-gray-400 truncate">
//             {selectedShop?.ShopName || 'Selected Shop'}
//           </p>
//         </div>

//         {/* Content */}
//         <div className="px-5 sm:px-6 py-4 sm:py-5 space-y-5">
//           {/* Location */}
//           <div className="space-y-1.5">
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
//               Location
//             </label>
//             {/* ... same location block as before ... */}
//             {!isGeolocationAvailable && (
//               <div className="p-2.5 bg-amber-50 dark:bg-amber-900/30 rounded-lg text-xs text-amber-700 dark:text-amber-400">
//                 Geolocation not supported by your browser
//               </div>
//             )}
//             {isGeolocationAvailable && !isGeolocationEnabled && (
//               <div className="p-2.5 bg-amber-50 dark:bg-amber-900/30 rounded-lg text-xs text-amber-700 dark:text-amber-400">
//                 Please enable location access in browser settings
//               </div>
//             )}
//             {geoError && (
//               <div className="p-2.5 bg-red-50 dark:bg-red-900/30 rounded-lg text-xs text-red-700 dark:text-red-400">
//                 Location error: {geoError.message || 'Unknown error'}
//               </div>
//             )}
//             {coords && (
//               <div className="p-3 bg-green-50 dark:bg-green-900/20 rounded-lg text-xs border border-green-200 dark:border-green-800">
//                 <span className="font-medium">Lat:</span> {coords.latitude.toFixed(6)} •{' '}
//                 <span className="font-medium">Lon:</span> {coords.longitude.toFixed(6)}
//                 <p className="text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
//                   {form.Address || 'Fetching address...'}
//                 </p>
//               </div>
//             )}
//           </div>

//           {/* Title */}
//           <div className="space-y-1.5">
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
//               Violation Title <span className="text-red-500">*</span>
//             </label>
//             <input
//               type="text"
//               value={form.Title}
//               onChange={(e) => setForm((prev) => ({ ...prev, Title: e.target.value }))}
//               placeholder="e.g. Shop open after repeated warnings"
//               className="w-full px-3.5 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all"
//               disabled={isSubmitting}
//             />
//           </div>

//           {/* Description */}
//           <div className="space-y-1.5">
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
//               Description <span className="text-red-500">*</span>
//             </label>
//             <textarea
//               value={form.Description}
//               onChange={(e) => setForm((prev) => ({ ...prev, Description: e.target.value }))}
//               rows={3}
//               placeholder="Describe the violation in detail..."
//               className="w-full px-3.5 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none resize-none min-h-[80px] transition-all"
//               disabled={isSubmitting}
//             />
//           </div>

//           {/* ── NEW: Violation Types ────────────────────────────────────── */}
//           <div className="space-y-2">
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
//               Violation Type <span className="text-red-500">*</span>
//               {form.violationTypes.length > 0 && (
//                 <span className="ml-2 text-xs text-gray-500 dark:text-gray-400">
//                   ({form.violationTypes.length} selected)
//                 </span>
//               )}
//             </label>

//             {violationData.length === 0 ? (
//               <div className="text-xs text-gray-500 dark:text-gray-400 italic">
//                 Loading violation types...
//               </div>
//             ) : (
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-48 overflow-y-auto pr-2">
//                 {violationData.map((type) => (
//                   <label
//                     key={type.id} // ← adjust according to your actual field name (id, ViolationTypeID, etc.)
//                     className="flex items-center gap-2.5 text-sm cursor-pointer group"
//                   >
//                     <input
//                       type="checkbox"
//                       checked={form.violationTypes.includes(type.ViolationsTypeID)}
//                       onChange={() => handleViolationTypeChange(type.ViolationsTypeID)}
//                       disabled={isSubmitting}
//                       className="w-4 h-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 dark:bg-gray-700 dark:border-gray-600"
//                     />
//                     <span className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-gray-100 transition-colors">
//                       {type.ViolationsType || ''}
//                     </span>
//                   </label>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* Photo / Camera */}
//           <div className="space-y-3">
//             <label className="block text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
//               Proof Photo <span className="text-red-500">*</span>
//             </label>
//             {/* ... rest of photo/camera section remains unchanged ... */}
//             {!form.ShopReportImage ? (
//               <div className="space-y-3">
//                 <div className="relative bg-black rounded-xl overflow-hidden aspect-[4/3] sm:aspect-video border-2 border-dashed border-gray-400 dark:border-gray-600 shadow-inner">
//                   <video
//                     ref={videoRef}
//                     className="w-full h-full object-cover"
//                     playsInline
//                     autoPlay
//                     muted
//                   />
//                   <canvas ref={canvasRef} className="hidden" width={640} height={480} />
//                   {!cameraActive && (
//                     <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-400 bg-black/60 text-center px-4">
//                       <span className="material-symbols-outlined text-5xl sm:text-6xl mb-2 opacity-80">
//                         photo_camera
//                       </span>
//                       <p className="text-sm font-medium">Tap to open camera</p>
//                     </div>
//                   )}
//                 </div>

//                 <div className="grid grid-cols-1 gap-2.5">
//                   <button
//                     type="button"
//                     onClick={handleOpenCamera}
//                     disabled={cameraActive || isSubmitting}
//                     className={`
//                       w-full py-3 px-4 rounded-lg font-medium flex items-center justify-center gap-2 text-sm transition-all
//                       ${cameraActive
//                         ? 'bg-gray-600 cursor-not-allowed text-white'
//                         : 'bg-blue-600 hover:bg-blue-700 text-white shadow-sm'}
//                     `}
//                   >
//                     <span className="material-symbols-outlined">photo_camera</span>
//                     Open Camera
//                   </button>
//                   {cameraActive && (
//                     <button
//                       onClick={takePhoto}
//                       className="w-full py-3.5 px-4 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium flex items-center justify-center gap-2 text-sm shadow-sm transition-all"
//                     >
//                       <span className="material-symbols-outlined">camera</span>
//                       Capture Photo
//                     </button>
//                   )}
//                 </div>
//               </div>
//             ) : (
//               <div className="space-y-2">
//                 <div className="relative rounded-xl overflow-hidden border border-gray-300 dark:border-gray-600 shadow-sm">
//                   <img
//                     src={imagePreview}
//                     alt="Captured proof"
//                     className="w-full h-40 sm:h-56 object-cover"
//                   />
//                   <button
//                     onClick={() => {
//                       setForm((prev) => ({ ...prev, ShopReportImage: null }));
//                       setImagePreview(null);
//                     }}
//                     disabled={isSubmitting}
//                     className="absolute top-2 right-2 bg-white/90 hover:bg-white dark:bg-black/70 dark:hover:bg-black/90 text-red-600 dark:text-red-400 p-2 rounded-full shadow-md transition-colors"
//                   >
//                     <span className="material-symbols-outlined text-lg">close</span>
//                   </button>
//                 </div>
//                 <p className="text-center text-xs text-green-600 dark:text-green-400 font-medium">
//                   Photo captured successfully
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="px-5 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/40 sticky bottom-0 backdrop-blur-sm">
//           <div className="flex justify-end gap-3">
//             <button
//               onClick={onClose}
//               disabled={isSubmitting}
//               className="px-5 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg font-medium transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSubmit}
//               disabled={isSubmitting}
//               className={`
//                 min-w-[130px] px-5 py-2 rounded-lg text-white text-sm font-medium flex items-center justify-center gap-2 shadow-md transition-all
//                 ${isSubmitting
//                   ? 'bg-gray-400 cursor-not-allowed shadow-none'
//                   : 'bg-red-600 hover:bg-red-700 shadow-red-600/30'}
//               `}
//             >
//               {isSubmitting && (
//                 <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
//               )}
//               {isSubmitting ? 'Submitting...' : 'Submit Report'}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ShopReportModal;import { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import axiosInstance from '../../API_Master/AxiosInstance';
import { NIGHT_EYE_API_URL } from '../../Process';
import { notifyError, notifySuccess } from '../../HelperMethods';
import { useGetViolatoinTypeDetails } from '../../API_Master/GetAPI';
import { useReliableGeolocation } from '../UseReliableGeolocation';
import { useEffect, useRef, useState } from 'react';

const ShopReportModal = ({ isOpen, refetch, onClose, selectedShop }) => {
  const { data: violationData = [] } = useGetViolatoinTypeDetails();

  const [form, setForm] = useState({
    Title: '',
    Description: '',
    violationTypes: [],
    ShopReportImage: null,
    Latitude: '',
    Longitude: '',
    Address: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSkipLocation, setShowSkipLocation] = useState(false);

  // Camera states
  const [cameraActive, setCameraActive] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);

  // Geolocation hook
  const {
    location,
    error: geoError,
    loading: geoLoading,
    permissionState,
    getLocation,
  } = useReliableGeolocation();

  // Reset form when modal opens
  useEffect(() => {
    if (!isOpen) return;

    setForm({
      Title: '',
      Description: '',
      violationTypes: [],
      ShopReportImage: null,
      Latitude: '',
      Longitude: '',
      Address: '',
    });
    setShowSkipLocation(false);
    setCameraActive(false);
    if (imagePreview) URL.revokeObjectURL(imagePreview);
    setImagePreview(null);
  }, [isOpen]);

  // Reverse geocode when location is available
  useEffect(() => {
    if (!location) return;

    const { latitude, longitude } = location;

    setForm((prev) => ({
      ...prev,
      Latitude: latitude.toFixed(6),
      Longitude: longitude.toFixed(6),
      Address: 'Fetching detailed address...',
    }));

    fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`
    )
      .then((res) => res.json())
      .then((data) => {
        const address = data.display_name || `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`;
        setForm((prev) => ({
          ...prev,
          Address: address.substring(0, 150),
        }));
      })
      .catch(() => {
        setForm((prev) => ({
          ...prev,
          Address: `${latitude.toFixed(5)}, ${longitude.toFixed(5)} (address lookup failed)`,
        }));
      });
  }, [location]);

  // ── Camera Functions ──────────────────────────────────────────────────
  const handleOpenCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'environment',
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play().catch((e) => console.error('Video play failed:', e));
        setCameraActive(true);
      }
    } catch (err) {
      let message = 'Failed to access camera.';
      if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        message = 'Camera permission denied. Please enable it in browser settings.';
      } else if (err.name === 'NotFoundError') {
        message = 'No camera detected on this device.';
      }
      notifyError(message);
    }
  };

  const takePhoto = () => {
    if (!videoRef.current || !canvasRef.current) return;

    const context = canvasRef.current.getContext('2d');
    if (!context) return;

    context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);

    canvasRef.current.toBlob(
      (blob) => {
        if (!blob) return;
        const file = new File([blob], `violation-report-${Date.now()}.jpg`, { type: 'image/jpeg' });
        setForm((prev) => ({ ...prev, ShopReportImage: file }));
        setImagePreview(URL.createObjectURL(file));

        videoRef.current.srcObject?.getTracks().forEach((track) => track.stop());
        videoRef.current.srcObject = null;
        setCameraActive(false);
        toast.success('Photo captured successfully');
      },
      'image/jpeg',
      0.85
    );
  };

  // ── Violation Type Handler ────────────────────────────────────────────
  const handleViolationTypeChange = (id) => {
    setForm((prev) => {
      const current = prev.violationTypes;
      if (current.includes(id)) {
        return { ...prev, violationTypes: current.filter((v) => v !== id) };
      } else {
        return { ...prev, violationTypes: [...current, id] };
      }
    });
  };

  // ── Submit Handler ────────────────────────────────────────────────────
  const handleSubmit = async () => {
    toast.dismiss();

    if (!form.Title.trim()) return notifyError('Violation Title is required');
    if (!form.Description.trim()) return notifyError('Description is required');
    if (form.violationTypes.length === 0) return notifyError('Please select at least one Violation Type');
    if (!form.ShopReportImage) return notifyError('Proof photo is required');

    // Location is optional — warn but allow submit
    if (!form.Latitude || !form.Longitude) {
      // if (!window.confirm('Location not captured. Submit report without coordinates?')) {
        return notifyError('Location not captured.')
      // }
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      console.log("hudhgf",form.violationTypes)
      const jsonViolationsTypeIDs = form.violationTypes.map(x => parseFloat(x));

      formData.append('ShopDetailID', selectedShop.ShopDetailID || '');
      formData.append('Title', form.Title.trim());
      formData.append('Description', form.Description.trim());
      // formData.append('ViolationTypeIDs', form.violationTypes.join(','));

      formData.append('ViolationsTypeIDs', JSON.stringify(jsonViolationsTypeIDs));
      const now = new Date();
      formData.append('ReportDate', now.toLocaleDateString('en-GB'));
      formData.append('ReportTime', now.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
      }));
      
      formData.append('Latitude', form.Latitude || '0');
      formData.append('Longitude', form.Longitude || '0');
      formData.append('Address', form.Address || 'Not captured');
      formData.append('CreatedByUserID', Cookies.get('NIGHT_EYE_USER_ID') || '');

      if (form.ShopReportImage) {
        formData.append('ShopReportImage', form.ShopReportImage);
      }

      const response = await axiosInstance.post(
        `${NIGHT_EYE_API_URL}shopReportDetail/setShopReportDetail`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response?.data?.status === true) {
        notifySuccess('Report submitted successfully!');
        refetch();
        onClose();
      }
    } catch (error) {
      notifyError(error.response?.data?.message || 'Failed to submit report');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-3 sm:p-4">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-lg max-h-[92vh] overflow-y-auto border border-gray-200 dark:border-gray-700 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
        
        {/* Header */}
        <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50/70 dark:bg-gray-800/40 sticky top-0 z-10 backdrop-blur-sm">
          <div className="flex items-center justify-between">
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
              Report Violation
            </h2>
            <button
              onClick={onClose}
              disabled={isSubmitting}
              className="text-gray-500 hover:text-gray-700 dark:text-gray-400 text-xl sm:text-2xl leading-none"
            >
              ×
            </button>
          </div>
          <p className="mt-0.5 text-xs sm:text-sm text-gray-600 dark:text-gray-400 truncate">
            {selectedShop?.ShopName || 'Selected Shop'}
          </p>
        </div>

        {/* Body */}
        <div className="px-5 sm:px-6 py-5 space-y-6">
          {/* ── LOCATION SECTION ───────────────────────────────────────────── */}
          <div className="space-y-4">
            {/* <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Current Location (recommended for better accuracy)
            </label> */}

            {/* Loading state */}
            {geoLoading && (
              <div className="py-8 flex flex-col items-center bg-gray-50 dark:bg-gray-800/50 rounded-xl">
                <div className="animate-spin h-10 w-10 border-4 border-blue-600 border-t-transparent rounded-full mb-4"></div>
                <p className="text-base font-medium text-gray-700 dark:text-gray-300">Locating you...</p>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">Please wait 5–60 seconds</p>
              </div>
            )}

            {/* Success state */}
            {location && !geoLoading && (
              <div className="p-5 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-800">
                <div className="flex items-center gap-3 mb-3">
                  <span className="material-symbols-outlined text-3xl text-green-600">check_circle</span>
                  <h3 className="text-base font-semibold text-green-700 dark:text-green-300">
                    Location captured!
                  </h3>
                </div>
                <div className="text-sm space-y-1 text-gray-700 dark:text-gray-300">
                  <p><strong>Lat:</strong> {location.latitude.toFixed(6)}</p>
                  <p><strong>Lng:</strong> {location.longitude.toFixed(6)}</p>
                  <p><strong>Accuracy:</strong> ±{Math.round(location.accuracy)} meters</p>
                  <p className="mt-3 font-medium">Address:</p>
                  <p className="break-words leading-relaxed text-gray-600 dark:text-gray-400">
                    {form.Address || 'Fetching detailed address...'}
                  </p>
                </div>
                <p className="text-xs text-green-600 dark:text-green-400 mt-3 italic">
                  Great! Location is now enabled — future reports will be faster.
                </p>
              </div>
            )}

            {/* Error / guidance state */}
            {geoError && !geoLoading && (
              <div className="p-5 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-200 dark:border-amber-800">
                <div className="flex items-start gap-3 mb-4">
                  <span className="material-symbols-outlined text-3xl text-amber-600">warning</span>
                  <div>
                    <h3 className="text-base font-semibold text-amber-800 dark:text-amber-300">
                      Location access blocked
                    </h3>
                    <p className="text-sm text-amber-700 dark:text-amber-300 mt-1">
                      {geoError}
                    </p>
                  </div>
                </div>

                {/* Guidance steps */}
                <div className="text-sm space-y-3 mt-4 text-gray-700 dark:text-gray-300">
                  <p className="font-medium">Quick fix (takes 30 seconds):</p>
                  <ol className="list-decimal pl-5 space-y-2">
                    <li>Open <strong>Settings</strong> app on your phone</li>
                    <li>Tap <strong>Privacy & Security</strong></li>
                    <li>Tap <strong>Location Services</strong></li>
                    <li>Make sure it's <strong>ON</strong> at the top</li>
                    <li>Scroll down and tap <strong>Safari Websites</strong></li>
                    <li>Change from <strong>Never</strong> to <strong>Ask Next Time</strong> or <strong>While Using</strong></li>
                  </ol>
                  {navigator.userAgent.includes('iPhone') && (
                    <p className="text-xs italic text-amber-700 dark:text-amber-400 mt-2">
                      iPhone note: You may need to allow twice — once in popup and once in Settings.
                    </p>
                  )}
                </div>

                {/* iOS "Go to Settings" button */}
                {navigator.userAgent.includes('iPhone') && (
                  <button
                    onClick={() => {
                      // Opens Settings → Privacy & Security → Location Services
                      window.location.href = 'App-prefs:root=Privacy&path=LOCATION';
                    }}
                    className="mt-5 w-full py-3.5 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium flex items-center justify-center gap-2 shadow-md transition-colors"
                  >
                    <span className="material-symbols-outlined">settings</span>
                    Go to Settings Now
                  </button>
                )}

                {/* Retry button */}
                <button
                  onClick={getLocation}
                  disabled={geoLoading || isSubmitting}
                  className="mt-4 w-full py-3 px-4 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-medium flex items-center justify-center gap-2 disabled:opacity-50 transition-colors"
                >
                  I've enabled it — Try Again
                </button>

                {/* Skip option */}
                <button
                  onClick={() => setShowSkipLocation(true)}
                  className="mt-3 w-full py-3 px-4 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 rounded-lg text-sm font-medium"
                >
                  Skip location for now
                </button>
              </div>
            )}

            {/* Initial state — no attempt yet */}
            {!location && !geoLoading && !geoError && (
              <div className="text-center">
                {/* <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                  Enable location to mark the violation accurately (like Google Maps)
                </p> */}
                <button
                  onClick={getLocation}
                  disabled={geoLoading || isSubmitting}
                  className="w-full py-4 px-6 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-medium text-base shadow-md flex items-center justify-center gap-3 disabled:opacity-50 transition-all"
                >
                  <span className="material-symbols-outlined text-xl">my_location</span>
                  Enable My Location
                </button>
              </div>
            )}

            {/* Skip confirmation dialog */}
            {showSkipLocation && (
              <div className="p-5 bg-gray-100 dark:bg-gray-800 rounded-xl text-sm">
                <p className="mb-4 text-gray-700 dark:text-gray-300">
                  Skipping location means the report will be less accurate for authorities.  
                  Continue without location?
                </p>
                <div className="flex gap-3">
                  <button
                    onClick={() => {
                      setForm((prev) => ({
                        ...prev,
                        Latitude: '0',
                        Longitude: '0',
                        Address: 'Skipped by user',
                      }));
                      setShowSkipLocation(false);
                      toast.info('Location skipped — report will still be submitted');
                    }}
                    className="flex-1 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium"
                  >
                    Yes, Skip
                  </button>
                  <button
                    onClick={() => setShowSkipLocation(false)}
                    className="flex-1 py-3 bg-gray-300 hover:bg-gray-400 rounded-lg font-medium"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Title */}
          <div className="space-y-1.5">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Violation Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={form.Title}
              onChange={(e) => setForm((prev) => ({ ...prev, Title: e.target.value }))}
              placeholder="e.g. Shop open after repeated warnings"
              className="w-full px-3.5 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
              disabled={isSubmitting}
            />
          </div>

          {/* Description */}
          <div className="space-y-1.5">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Description <span className="text-red-500">*</span>
            </label>
            <textarea
              value={form.Description}
              onChange={(e) => setForm((prev) => ({ ...prev, Description: e.target.value }))}
              rows={3}
              placeholder="Describe the violation in detail..."
              className="w-full px-3.5 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none resize-none min-h-[80px] transition-all"
              disabled={isSubmitting}
            />
          </div>

          {/* Violation Types */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Violation Type <span className="text-red-500">*</span>
              {form.violationTypes.length > 0 && (
                <span className="ml-2 text-xs text-gray-500 dark:text-gray-400">
                  ({form.violationTypes.length} selected)
                </span>
              )}
            </label>

            {violationData.length === 0 ? (
              <div className="text-xs text-gray-500 dark:text-gray-400 italic">
                Loading violation types...
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-48 overflow-y-auto pr-2">
                {violationData.map((type) => {
                  const id = type.ViolationsTypeID || type.id;
                  return (
                    <label
                      key={id}
                      className="flex items-center gap-2.5 text-sm cursor-pointer group"
                    >
                      <input
                        type="checkbox"
                        checked={form.violationTypes.includes(id)}
                        onChange={() => handleViolationTypeChange(id)}
                        disabled={isSubmitting}
                        className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <span className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-gray-100 transition-colors">
                        {type.ViolationsType || type.name || 'Unknown Type'}
                      </span>
                    </label>
                  );
                })}
              </div>
            )}
          </div>

          {/* Photo / Camera */}
          <div className="space-y-3">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Proof Photo <span className="text-red-500">*</span>
            </label>

            {!form.ShopReportImage ? (
              <div className="space-y-3">
                <div className="relative bg-black rounded-xl overflow-hidden aspect-[4/3] sm:aspect-video border-2 border-dashed border-gray-400 dark:border-gray-600 shadow-inner">
                  <video
                    ref={videoRef}
                    className="w-full h-full object-cover"
                    playsInline
                    autoPlay
                    muted
                  />
                  <canvas ref={canvasRef} className="hidden" width={640} height={480} />
                  {!cameraActive && (
                    <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-400 bg-black/60 text-center px-4">
                      <span className="material-symbols-outlined text-5xl sm:text-6xl mb-2 opacity-80">
                        photo_camera
                      </span>
                      <p className="text-sm font-medium">Tap to open camera</p>
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-1 gap-2.5">
                  <button
                    type="button"
                    onClick={handleOpenCamera}
                    disabled={cameraActive || isSubmitting}
                    className={`
                      w-full py-3 px-4 rounded-lg font-medium flex items-center justify-center gap-2 text-sm transition-all
                      ${cameraActive
                        ? 'bg-gray-600 cursor-not-allowed text-white'
                        : 'bg-blue-600 hover:bg-blue-700 text-white shadow-sm'}
                    `}
                  >
                    <span className="material-symbols-outlined">photo_camera</span>
                    Open Camera
                  </button>

                  {cameraActive && (
                    <button
                      onClick={takePhoto}
                      className="w-full py-3.5 px-4 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium flex items-center justify-center gap-2 text-sm shadow-sm transition-all"
                    >
                      <span className="material-symbols-outlined">camera</span>
                      Capture Photo
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div className="space-y-2">
                <div className="relative rounded-xl overflow-hidden border border-gray-300 dark:border-gray-600 shadow-sm">
                  <img
                    src={imagePreview || ''}
                    alt="Captured proof"
                    className="w-full h-40 sm:h-56 object-cover"
                  />
                  <button
                    onClick={() => {
                      setForm((prev) => ({ ...prev, ShopReportImage: null }));
                      setImagePreview(null);
                    }}
                    disabled={isSubmitting}
                    className="absolute top-2 right-2 bg-white/90 hover:bg-white dark:bg-black/70 dark:hover:bg-black/90 text-red-600 dark:text-red-400 p-2 rounded-full shadow-md transition-colors"
                  >
                    <span className="material-symbols-outlined text-lg">close</span>
                  </button>
                </div>
                <p className="text-center text-xs text-green-600 dark:text-green-400 font-medium">
                  Photo captured successfully
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="px-5 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/40 sticky bottom-0 backdrop-blur-sm">
          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              disabled={isSubmitting || geoLoading}
              className="px-5 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg font-medium transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={isSubmitting}
              className={`
                min-w-[140px] px-6 py-2.5 rounded-lg text-white font-medium flex items-center justify-center gap-2 shadow-md transition-all
                ${isSubmitting ? 'bg-gray-400 cursor-not-allowed shadow-none' : 'bg-red-600 hover:bg-red-700 shadow-red-600/30'}
              `}
            >
              {isSubmitting && (
                <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
              )}
              {isSubmitting ? 'Submitting...' : 'Submit Report'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopReportModal;